export const colors = [
  "#E9AFAA",
  "#EAFF8F",
  "#B7EB8F",
  "#F3DF8B",
  "#C3E1E8",
  "#FFE58F",
  "#D3ADF7",
  "#FFADD2",
  "#FFF2E8",
  "#C3D2E8",
];
